package gr.tech.site.pages.blog

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initThethcgirlsPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("blog/thethcgirls.md", FrontMatterElement.Builder { addScalar("title", "The THC Girls (and Guy) Stopped By | Podcast"); addScalar("description", "In the episode, we talked about their journey as cannabis marketing wizards, the harms of miseducation especially concerning terps, and the importance of relationships in such a turbulent industry."); addScalar("author", "Ethan Cohen"); addScalar("image", "/images/blog/thcgirls.png"); addScalar("date", "2026-04-13"); addScalar("updated", "2026-04-13"); }))
}

@Page("/blog/the-thc-girls-and-guy-stopped-by-podcast")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun ThethcgirlsPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("the-thc-girls-and-guy-stopped-by") }) {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("THE THC GIRLS (AND GUY) STOPPED BY")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Leading up to MJBiz 2025, an Instagram page caught my eye. It was the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/thehighcountrygirls/") {
            org.jetbrains.compose.web.dom.Text("THC GIRLS")
        }
        org.jetbrains.compose.web.dom.Text(". Honestly, I didn’t know what services they provided, but they just seemed like the type of folks with the coolest stories at the party. Like the time they ate In n Out burger with Anthony Bourdain. They sadly didn’t have that experience, but the point is, I wouldn’t be surprised if they did. Note to self: don’t ask random people if they’ve ever eaten In n Out with a late and great food icon.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("In the episode, we talked about their journey as cannabis marketing wizards, the harms of miseducation especially concerning terps, and the importance of relationships in such a turbulent industry. I sat down with ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/mthrfknjones/") {
            org.jetbrains.compose.web.dom.Text("Krysta Jones")
        }
        org.jetbrains.compose.web.dom.Text(",  ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/highimsanja/") {
            org.jetbrains.compose.web.dom.Text("Sanja Ganja")
        }
        org.jetbrains.compose.web.dom.Text(" and ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/agfromthe303/") {
            org.jetbrains.compose.web.dom.Text("Adrian Garcia")
        }
        org.jetbrains.compose.web.dom.Text(", three folks I’m a better person for knowing. We recently shared a ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.instagram.com/p/DW4VNIUPvmc/") {
            org.jetbrains.compose.web.dom.Text("clip on IG")
        }
        org.jetbrains.compose.web.dom.Text(" that has amassed over 10k views, showing the value of their wisdom.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Watch the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.youtube.com/watch?v=9C9_NtXmHuU&feature=youtu.be") {
            org.jetbrains.compose.web.dom.Text("full episode")
        }
        org.jetbrains.compose.web.dom.Text(" on the ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://www.youtube.com/@moneytalksthepod") {
            org.jetbrains.compose.web.dom.Text("Money Talks YouTube channel")
        }
        org.jetbrains.compose.web.dom.Text(". We’ve interviewed over 50 Cannabis Experts and that number grows by the trade show!")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Let’s make 2026 the year of Free Money. We’ve already completed a few exciting projects, a few amassing over 6 figures in rebates for cannabis cultivators around the country. Fill out our ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://greenrebates.com/contact-us/") {
            org.jetbrains.compose.web.dom.Text("free estimate form")
        }
        org.jetbrains.compose.web.dom.Text(", and a team member will be in touch to start calculating that free money!")
    }
    com.varabyte.kobweb.silk.components.layout.HorizontalDivider()
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.B {
            org.jetbrains.compose.web.dom.Text("Related:")
        }
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/article/the-2026-guide-to-cannabis-rebates-how-to-get-paid-for-your-grow-upgrades") {
                org.jetbrains.compose.web.dom.Text("The 2026 Guide to Cannabis Rebates: How to Get Paid for Your Grow Upgrades")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/hall-of-flowers-2026") {
                org.jetbrains.compose.web.dom.Text("Hall of Flowers 2026")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/blog/green-rebates-cannabis-business-times-2026-best-cannabis-companies-to-work") {
                org.jetbrains.compose.web.dom.Text("We Made The List! | Cannabis Business Times 2026 Best Cannabis Companies To Work")
            }
        }
    }
}
